export enum Gender {
  MALE = 'männlich',
  FEMALE = 'weiblich',
  NONE = 'keine Angabe'
}
